module.exports = __webpack_public_path__ + "img/action_form.084a2ecf.png";